import { addOrUpdateConversationDataMutator } from './helpers/addOrUpdateConversationData';
import { addOrUpdateItemDataMutator } from './helpers/addOrUpdateItemData';
import type { MailListRowDataType, TableView } from 'owa-mail-list-store';
import type { ConversationType, ItemRow } from 'owa-graph-schema';
import type { LoadConversationItemActionSource } from 'owa-mail-store';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Adds or updates the row in the tableView
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param row to add or update
 * @param tableView to be loaded
 * @param loadSource source that triggered this row data update
 * @param doNotOverwriteData determines if updates should be written (default is false)
 * @param state the AddOrUpdateRowDataState
 */
export function addOrUpdateRowDataMutator(
    row: MailListRowDataType,
    tableView: TableView,
    loadSource: LoadConversationItemActionSource,
    doNotOverwriteData: boolean = false
): void {
    switch (tableView.tableQuery.listViewType) {
        case 0:
            addOrUpdateConversationDataMutator(
                row as ConversationType,
                tableView,
                doNotOverwriteData,
                loadSource
            );
            break;

        case 1:
            addOrUpdateItemDataMutator(row as ItemRow, tableView, loadSource);
            break;
    }
}
